// extracted by mini-css-extract-plugin
export default {"filterList":"FilterBlock_filterList__pTEaq"};